import React from 'react';
import { useOutletContext } from 'react-router';
import giftingLogo from 'assets/logo/embark_gifting_logo.svg';
import brandmarkLogo from 'assets/logo/embark_brandmark_standard.svg';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import Button from '@Components/Button';
import { getGiftAboutText, getGiftAboutList } from './services';
import RedirectIcon from 'assets/icons/redirect_icon.svg';
import Link from '@Components/Link';
import { Avatar } from '@mui/material';
import { getInitials } from '@Utilities/services/name';
import './styles/giftAbout.scss';

export default function GiftAbout() {
  const { localized, beneficiary, onGiftNowClick, locale } = useOutletContext();
  const termsLink = locale === 'fr-CA' ? __GIFTING__GIFTER__TERMS__FR__ : __GIFTING__GIFTER__TERMS__EN__;
  const { profilePictureUrl, firstName, lastInitial } = beneficiary || {};
  const { header, body } = getGiftAboutText(localized, firstName, locale);
  const listItems = getGiftAboutList(localized);

  return (
    <div className='send-a-gift-about'>
      <div className='send-a-gift-about__content'>
      <div className='send-a-gift-about__content__logo'><img src={giftingLogo}/></div>
      <div className='send-a-gift-about__content__img'>
        {profilePictureUrl ? (
          <Avatar
            alt={getInitials(firstName, lastInitial)}
            src={profilePictureUrl}
          />
        ) : (
          <Avatar>
            {getInitials(firstName, lastInitial) || (<PermIdentityIcon />)}
          </Avatar>
        )}
        <img className='send-a-gift-about__content__img__logo' src={brandmarkLogo} />
      </div>
      <div className='send-a-gift-about__content__header'>{header}</div>
      <div className='send-a-gift-about__content__body'>{body}</div>
      <Button
        onClick={onGiftNowClick}
        className='send-a-gift-about__content__gift-btn'
        variant='tonal'
      >
        {localized['gifting.about.button']}
      </Button>
      </div>
      <div className='send-a-gift-about__list'>
        <div className='send-a-gift-about__list__header'>{localized['gifting.list.header']}</div>
        <div className='send-a-gift-about__list__list'>
          {listItems.map((item) => {
            return (
              <div key={item.id} className='send-a-gift-about__list__list__item'>
                <div>
                  <img alt={item.alt} src={item.image} />
                </div>
                <div className='send-a-gift-about__list__list__item__text'>
                  <div className='send-a-gift-about__list__list__item__text__header'>{item.header}</div>
                  <div className='send-a-gift-about__list__list__item__text__body'>
                    {item.body}{item.bodyTwo && <b> {item.bodyTwo}</b>}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Button
        size='large'
        onClick={onGiftNowClick}
        className='send-a-gift-about__content__gift-btn--bottom'
        variant='tonal'
      >
        {localized['gifting.about.button']}
      </Button>
      <div className='send-a-gift-about__terms'>
        <span className='send-a-gift-about__terms__body'>
          {localized['gifting.about.terms.body']}
        </span>
        <span>
          <Link className='send-a-gift-about__terms__link' href={termsLink} opensInNewTab>
            {localized['gifting.about.terms.link']}
            <img src={RedirectIcon} alt={localized['gifting.about.terms.alt']}/>
          </Link>
        </span>
      </div>
    </div>
  );
}
